/* eslint-disable import/prefer-default-export */
import { ColumnProps, ColumnType } from '@src/components/data.grid'
import type { ShadowNetworkItem } from '@src/redux/reducers/external.lists/default.state'
import { Routes } from '@src/constants/routes'
import type { ShadowAccountColumnsOptions } from '../models'

export const getShadowNetworkColumns = ({
  goToSearchResult
}: ShadowAccountColumnsOptions): ColumnProps<ShadowNetworkItem>[] => [
  { type: ColumnType.selector },
  {
    field: 'network_ip',
    title: 'Network IP'
  },
  {
    field: 'network_name',
    title: 'Network Name'
  },
  {
    field: 'account_id',
    title: 'Account'
  },
  {
    field: 'out_obj_store',
    title: 'Object Stores',
    onClick: (item, column, history) => {
      const query = `network_node with-attribute uri ${item.uri} with-access object_store with-attribute accountid ${item.account_id}`
      goToSearchResult(query)
      history.push(Routes?.pages?.searchResult?.path)
    }
  },
  {
    field: 'out_sg',
    title: 'Security Groups',
    onClick: (item, column, history) => {
      const query = `network_node with-attribute uri ${item.uri} with-access security_group with-attribute accountid ${item.account_id}`
      goToSearchResult(query)
      history.push(Routes?.pages?.searchResult?.path)
    }
  }
]
